module.exports = __webpack_public_path__ + "img/market-potential.911c9258.svg";